module.exports = __webpack_public_path__ + "static/media/call.f4424dad.svg";